// Browser gzip via the native Compression Streams API (no third-party dep).
// CompressionStream/DecompressionStream ship in all current evergreen browsers and are
// already relied on elsewhere in this app (analytics-traffic.jsx). These are async —
// callers must await. Returns Uint8Array.

async function runThroughStream(bytes, stream) {
  const input = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  const writer = stream.writable.getWriter();
  writer.write(input);
  writer.close();
  const reader = stream.readable.getReader();
  const chunks = [];
  let total = 0;
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    chunks.push(value);
    total += value.byteLength;
  }
  const out = new Uint8Array(total);
  let off = 0;
  for (const c of chunks) { out.set(c, off); off += c.byteLength; }
  return out;
}

export function gzip(bytes) {
  if (typeof CompressionStream === 'undefined') {
    throw new Error('CompressionStream not supported in this browser');
  }
  return runThroughStream(bytes, new CompressionStream('gzip'));
}

export function gunzip(bytes) {
  if (typeof DecompressionStream === 'undefined') {
    throw new Error('DecompressionStream not supported in this browser');
  }
  return runThroughStream(bytes, new DecompressionStream('gzip'));
}

export function gzipSupported() {
  return typeof CompressionStream !== 'undefined' && typeof DecompressionStream !== 'undefined';
}
